import React from 'react';

import styles from './ReadOnlyZone.module.scss';

/**
 * Makes a subtree non-interactive when `locked`: `inert` blocks clicks, focus
 * and typing for native inputs and composite widgets alike (react-select,
 * pickers), which `disabled` on each control would not cover. Used by the
 * order edit policy (@modules/logic/orderEditPolicy).
 */
export default function ReadOnlyZone({ locked = false, className, title, children, ...rest }) {
  const classes = [className, locked ? styles.locked : null].filter(Boolean).join(' ');
  return (
    <div
      {...rest}
      className={classes || undefined}
      inert={locked || undefined}
      aria-disabled={locked || undefined}
      title={locked ? title : undefined}
    >
      {children}
    </div>
  );
}
